import React from 'react';
export var FormError = function FormError(props) {
  return /*#__PURE__*/React.createElement("div", null, props.error, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: props.clear
  }, "\xD7"));
};